"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessView = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const custom_image_1 = require("../../custom-image");
const styled_1 = require("../styled");
const styled_2 = require("./styled");
const disable_focus_wrapper_1 = require("../../disable-focus-wrapper");
const index_1 = require("../../index");
const SuccessView = ({ imageAlt, imageUrl, imagePlacegholder, srcErrorImage, okHandler }) => (react_1.default.createElement(styled_1.StateWrapper, { className: "success-state-wrapper" },
    react_1.default.createElement(styled_1.ContentWrapper, { className: "content-wrapper" },
        react_1.default.createElement(styled_2.HeaderWrapper, { className: "header-wrapper" },
            react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.headline300, bold: true, textAlign: components_core_1.TextAlignment.center }, "Thank you for contacting us!")),
        react_1.default.createElement(styled_2.TextWrapper, { className: "text-wrapper" },
            react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.headline200, textAlign: components_core_1.TextAlignment.center },
                "We have received your message. ",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                "Our team will contact you as soon as possible to give you the information you need.")),
        react_1.default.createElement(styled_2.ImageWrapper, { className: "image-wrapper" },
            react_1.default.createElement(custom_image_1.CustomImage, { src: imageUrl || '', alt: imageAlt || '', srcPlaceholder: imagePlacegholder || '', srcErrorImage: srcErrorImage || '' })),
        react_1.default.createElement(disable_focus_wrapper_1.DisableFocusWrapper, null,
            react_1.default.createElement(index_1.Button, { appearance: index_1.ButtonAppearance.Primary, onClick: okHandler }, "Okay")))));
exports.SuccessView = SuccessView;
